import { FunctionComponent } from "react";
import { Avatar as MuiAvatar } from "@mui/material";

interface AvatarProps {
	firstName?: string;
	lastName?: string;
	imageSrc?: string;
}

export const Avatar: FunctionComponent<AvatarProps> = ({ firstName, lastName, imageSrc }) => {
	return (
		<MuiAvatar
			src={imageSrc}
			sx={{
				height: 44,
				width: 44,
				cursor: "pointer",
				borderRadius: "12px",
				backgroundColor: "#F7F8FB",
				color: "#777D8D",
			}}
		>
			{firstName &&
				lastName &&
				`${firstName.split("")[0].toUpperCase()}${lastName.split("")[0].toUpperCase()}`}
		</MuiAvatar>
	);
};
